import React from 'react';
import styles from './TrustedSection.module.scss';
import heather from './images/heather.jpeg';
import mike from './images/mike.jpeg';
import vishen from './images/vishen.png';
import nicole from './images/nicole.jpg'

const TrustedSection = () => {
  const testimonials = [
    {
      image: mike,
      name: 'Mike Pell',
      company: 'Director at The Microsoft Garage',
      description:
        "Vocable isn't just another AI writing tool - it's a comprehensive content system that transforms a scattered, overwhelming process into something remarkably simple. Vocable's vision for unifying multi-channel content workflows under one platform is exactly what the industry needs.",
      overlay: ['#fff5', '#F8C864D9'],
    },
    {
      image: heather,
      name: 'Heather Monahan',
      company: 'Top 50 Keynote Speaker and Bestselling Author',
      description:
        "I was spending SO many hours trying to keep up with LinkedIn posts and email campaigns that matched my message. Now? I literally type in one core idea and boom—I've got a month of new content ready to be reviewed.. My team is obsessed because what took days now happens in minutes.",
      overlay: ['#fff5', '#2247A8D9'],
    },
    {
      image: vishen,
      name: 'Vishen Lakhiani',
      company: 'Founder of Mindvalley',
      description:
        "I was intrigued the moment I saw Vocable's first demo on the Mindvalley stage. If you're serious about turning your expertise into high-impact content, this platform makes it so easy to create 10x more on-brand content across different channels.",
      overlay: ['#fff5', '#00A7B7D9'],
    },
    // Nicole DeAvilla - Best Selling Author, Blogger, AI Advisor
    {
      image: nicole,
      name: 'Nicole DeAvilla',
      company: 'Best Selling Author, Blogger, AI Advisor',
      description:
        'Vocable AI is brilliant! It combines a variety of A.I. models backed by the expertise of marketers. I have three different brands and different branded programs. Vocable allows me to seamlessly move from one brand style to the next all on the same platform',
      overlay: ['#fff5', '#2247A8D9'],
    },
  ];

  return (
    <section className={styles.trustedSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Trusted by Industry Pioneers</h2>
        <p className={styles.subtitle}>
          Here's why AI experts and content leaders are excited about Vocable's
          impact on the future of content creation
        </p>

        <div className={styles.testimonials}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={styles.testimonialCard}>
              <div
                className={styles.imageWrapper}
                style={{
                  '--overlay-start': testimonial.overlay[0],
                  '--overlay-end': testimonial.overlay[1],
                }}
              >
                <img src={testimonial.image} alt={testimonial.name} />
                <div className={styles.overlay}>
                  <h3>{testimonial.name}</h3>
                  <p className={styles.company}>{testimonial.company}</p>
                </div>
              </div>
              <div
                className={styles.content}
                style={{ '--overlay': testimonial.overlay[1] }}
              >
                <h3>{testimonial.name}</h3>
                {testimonial.description && (
                  <>
                    <p className={styles.description}>
                      {testimonial.description}
                    </p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;
